/**
 * Created by tomers on 12/18/2014.
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");

    var TagItemModel = BaseModel.extend({
        defaults: {
            value: "",          // tag text
            subText: "",
            closeable: true,     // has close button
            separator: ""     // separator text, optional
        },

        getValue: function() {
            return this.get("value");
        },
        getSubText: function() {
            return this.get("subText");
        }
    });

    return TagItemModel;
});
